import React, { useEffect } from 'react';
import TemplateCMS from 'components/commercetools-ui/aafes/templateCms';

const AssetsCmsTastics = (cmsContent) => {
  return <>{cmsContent && <TemplateCMS cmsContent={cmsContent?.data} />}</>;
};

export default AssetsCmsTastics;
